<article
  class="sidebar-panel"
  [class.sidebar-panel--priority]="panel().showHighPriorityIndicator"
>
  <header class="sidebar-panel__header">
    <div class="sidebar-panel__heading">
      <app-agility-button
        [data-testid]="'sidebar-' + panel().id + '-toggle'"
        [ariaLabel]="panel().toggleAriaLabel"
        [id]="'sidebar-' + panel().id + '-toggle'"
        buttonType="button"
        variant="text"
        [icon]="isOpen() ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
        [ariaExpanded]="isOpen()"
        [attr.ariaControls]="contentId"
        (click)="panelToggle.emit()"
      ></app-agility-button>
      <i [class]="panel().icon" aria-hidden="true"></i>
      <a [id]="headingId" [routerLink]="panel().route">{{ panel().label }}</a>
    </div>
    @if (isLoading() | async) {
      <app-agility-loading-spinner
        [style]="{ height: '1.3rem', width: '1.3rem' }"
        [ariaLabel]="'Loading indicator for ' + panel().label + ' panel'"
        [dataTestId]="'sidebar-' + panel().id + '-loading-spinner'"
      ></app-agility-loading-spinner>
    }
  </header>

  <section
    [id]="contentId"
    class="sidebar-panel__content"
    [class.sidebar-panel__content--open]="isOpen()"
    [attr.aria-labelledby]="headingId"
  >
    <div class="sidebar-panel__content-body">
      @for (
        anchor of (panel().counts$ | async) ?? [];
        track anchor.description
      ) {
        <a
          [routerLink]="panel().route"
          [queryParams]="getLinkQueryParams(anchor)"
          class="sidebar-panel__link"
        >
          <span>{{ anchor.description }}</span>
          @if (panel().showHighPriorityIndicator) {
            <span>
              <span>
                @if (anchor.highPriorityCount) {
                  <i
                    class="pi pi-exclamation-circle"
                    aria-hidden="true"
                    pTooltip="High priority loans"
                    tooltipPosition="top"
                  ></i>
                  <span class="sidebar-panel__sr-only"
                    >Includes high priority loans</span
                  >
                }
              </span>
              <span>{{ anchor.count | number }}</span>
            </span>
          } @else {
            <span>{{ anchor.count | number }}</span>
          }
        </a>
      }
    </div>
  </section>
</article>
